/** Faz JSON.parse + validação com o schema, sem lançar exceção. */
export function parseMessage(schema, raw) {
    let text;
    if (typeof raw === 'string') {
        text = raw;
    }
    else {
        text = new TextDecoder().decode(raw);
    }
    let json;
    try {
        json = JSON.parse(text);
    }
    catch {
        return { ok: false, error: 'JSON inválido' };
    }
    const result = schema.safeParse(json);
    if (!result.success) {
        return { ok: false, error: result.error.issues.map((i) => `${i.path.join('.')}: ${i.message}`).join('; ') };
    }
    return { ok: true, value: result.data };
}
//# sourceMappingURL=parse.js.map